import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import {
  Typography,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemSecondaryAction
} from '@material-ui/core';
import RTVAvatar from '../RTVAvatar';

const styles = theme => ({
  primaryText: {
    fontSize: '1.2rem',
    divider: {
      borderBottomColor: fade(theme.palette.primary.main, 0.2)
    },
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    '& > p': {
      fontSize: '1.2rem'
    },
    [theme.breakpoints.down('xs')]: {
      flexFlow: 'column',
      alignItems: 'flex-start',
      '& > p': {
        marginLeft: '0 !important'
      }
    }
  },
  textLink: {
    color: theme.palette.text.primary,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  avatar: {
    backgroundColor: '#fff',
    width: '60px',
    height: '60px',
    boxShadow: '0 0 15px 0 rgba(0, 0, 0, 0.06)',
    '& > svg': {
      width: '50px',
      height: '50px'
    },
    [theme.breakpoints.down('xs')]: {
      width: '56px',
      height: '56px'
    }
  },
  listAvatar: {
    marginRight: theme.spacing(1)
  }
});

const NewParentComment = ({ notification, key, classes, noBorder }) => (
  <ListItem
    key={key}
    alignItems="flex-start"
    divider={!noBorder}
    classes={{
      divider: classes.divider
    }}
  >
    <ListItemAvatar className={classes.listAvatar}>
      <RTVAvatar
        className={classes.avatar}
        src={
          notification.comment.author.media
            ? notification.comment.author.media.default_small
            : null
        }
        alt="avatar"
      />
    </ListItemAvatar>
    <ListItemText
      primary={
        <Typography component="span" className={classes.primaryText}>
          {notification.comment.author.username}
          <Typography style={{ marginLeft: '4px', fontWeight: 400 }}>
            comentó en{' '}
            <Link
              style={{ color: '#000', textDecoration: 'none' }}
              to={`/producto/id/${notification.comment.product.id}`}
            >
              {notification.comment.product.title}
            </Link>
          </Typography>
        </Typography>
      }
      secondary={notification.timePassedString}
    />
    <ListItemSecondaryAction>
      {/* TODO(Toti): Missing product image */}
    </ListItemSecondaryAction>
  </ListItem>
);

export default withStyles(styles)(NewParentComment);
